import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-add-note-request",
  templateUrl: "./add-note-request.component.html",
  styles: [],
})
export class AddNoteRequestComponent implements OnInit {
  @Input() content: any;
  test: Date = new Date();
  requestForm: FormGroup;
  submitted = false;
  errorMessage = "";
  successMessage = "";
  loader = false;

  constructor(
    public dialogRef: NgbActiveModal,
    public fb: FormBuilder,
    public service: PageService,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    console.log(this.content.requestId);
    this.requestForm = this.fb.group({
      note: ["", [Validators.required]],
    });
  }

  get f() {
    return this.requestForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.requestForm.invalid) {
      return;
    }
    this.loader = true;
    const formData = {
      note: this.requestForm.get("note").value,
    };
    this.service
      .postMethod("callbackRequest/addNote/" + this.content.requestId, formData)
      .then((data) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      });
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
